module.exports = __webpack_public_path__ + "img/mp4.92c42cb0.svg";